import React from 'react';
import classes from './LoginBox.module.scss'
import {Box} from "@material-ui/core";
import SignIn from "../../../../components/SignIn/SignIn";

const LoginBox = () => (
    <Box className={classes.LoginBox}>

        <SignIn/>
     </Box>

);

export default LoginBox;
//     <form noValidate autoComplete="off">
//         <FormGroup>
//         <TextField id="standard-basic" label="Username or E-mail" variant="outlined" />
//         </FormGroup>
//         <FormGroup>
//         <TextField id="standard-basic2" label="Password" variant="outlined"/>
//         </FormGroup>
//         <Button variant="contained" color="primary">Save</Button>
//     </form>
